import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import * as actions from 'actions'

class ArchiveTeamPhoto extends Component {
  selectUser = (userId) => {
    let {dispatch} = this.props
    dispatch(actions.token.selectUser(userId))
  }
  render() {
    let avatar = this.props.photoPath + this.props.member.id + '.jpg'

    return (
      <div className="avatar-small" onClick={this.selectUser.bind(this, this.props.member.id)}>
        <img src={assets(avatar)} />
      </div>
    )
  }
}
ArchiveTeamPhoto.contextTypes = {
}
ArchiveTeamPhoto.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ArchiveTeamPhoto)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveTeamPhoto.js